import React from "react";

// @mui material
import Container from "@mui/material/Container";

// Icons
import GitHubIcon from "@mui/icons-material/GitHub";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import Email from "@mui/icons-material/Email";
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

export default function Footer() {
  return (
    <>
      <div className="footer">
        <Container maxWidth="lg">
          <h2 className="text-white">Contact Me!</h2>
          <p className="lead ">
            Got a project? A question? Or perhaps you have an inquiry? My inbox awaits!
          </p>
          <p className=" work">
            Full Stack Web Developer (Laravel, Reactjs ) | Freelancer | Syrian
          </p>

       <div className="social-icon" style={{ display: 'flex', gap: '10px' }}>  
              {/* LinkedIn */}
              <a
                rel="noopener noreferrer"  
                href="https://www.linkedin.com/in/elham-alassta"
                target="_blank"
                aria-label="Elham Alassta's LinkedIn Profile"
                className="icon-link linkedin-bg" 
              >
                <LinkedInIcon />
              </a>

              {/* GitHub */}
                {/*
              <a
                rel="noopener noreferrer"  
                href=""
                target="_blank"
                aria-label="Elham Alassta's GitHub Profile"
                className="icon-link github-bg" 
              >
                <GitHubIcon />
              </a>
*/}
              {/* Email */}
              <a
                rel="noopener noreferrer" 
                href="mailto:ealassta@gmail.com" 
                target="_blank"
                aria-label="Email Elham Alassta"
                className="icon-link email-bg" 
              >
                <Email />
              </a>

              {/* WhatsApp */}
              <a
                rel="noopener noreferrer"
                href="https://wa.me/963935821242"  
                target="_blank"
                aria-label="Contact Elham Alassta on WhatsApp"
                className="icon-link whatsapp-bg" 
              >
                <WhatsAppIcon />
              </a>
            </div>
          </Container>
      </div>
    </>
  );
}




